import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, of, Subscription, switchMap, timer } from 'rxjs';
import { Constants } from '../models/contant';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeploymentCheckService {
  private deploymentApiUrl = `${Constants.CONSUMER_BASE_API_URL}/getActiveDowntimeWindow?requestType=DOWNTIME_PAGE_STATUS`;
  private deploymentInProgress = false;
  private message = '';
  private messageSource = new BehaviorSubject<any>(null);
  currentMessage = this.messageSource.asObservable();
  private pollingSubscription: Subscription | undefined;
  constructor(private http: HttpClient, private router: Router, private datePipe: DatePipe) { }

  startPolling(): void {
    timer(1000, Constants.deploymentWindowCheckTimeInSeconds) // Poll every 1 minutes
      .pipe(
        switchMap(() => this.getActiveDowntimeWindow().pipe(
          catchError((error) => {
            return of(null);
          })
        )), // Get active downtime window API
      ).subscribe({
        next: (res: any) => {
          if (res?.downtime) {
            let startDate = this.getDate(res?.downtimeStartTime);
            let startTime = this.getStartTime(res?.downtimeStartTime);
            let endDate = this.getDate(res?.downtimeEndTime);
            let endTime = this.getEndTime(res?.downtimeEndTime);
            if (res?.downtimeType?.toLowerCase() === 'maintenance') {
              const message = this.getMaintenanceMessage(startDate, startTime, endTime);
              this.router.navigate(['maintenance']);
              setTimeout(() => {
                this.changeMessage({ type: 'maintenance page', message: message, downtime: true, redirectToLogout: false });
              }, 1000);
            } else if (res?.downtimeType?.toLowerCase() === 'ribbon') {
              const message = this.getRibbonMessage(startDate, startTime, endDate, endTime);
              setTimeout(() => {
                this.changeMessage({ type: 'ribbon', message: message, downtime: true, redirectToLogout: false });
              }, 1000);
            }
          } else {
            this.changeMessage({ type: '', message: '', downtime: false, redirectToLogout: false });
          }
        },
        error: (error) => {
          console.error('Unexpected error in polling:', error);
        }
      });
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription?.unsubscribe();
    }
  }

  isDeploymentInProgress(): boolean {
    return this.deploymentInProgress;
  }

  getMessage(): string {
    return this.message;
  }

  getActiveDowntimeWindow() {
    return this.http.get<any>(this.deploymentApiUrl);
  }

  changeMessage(message: { type: any, message: any, downtime: any, redirectToLogout: boolean }) {
    this.messageSource.next(message);
  }

  getRibbonMessage(startDate: any, startTime: any, endDate: any, endTime: any) {
    return `<b>All services</b> in the application will be <b>unavailable</b> due to scheduled maintenance from 
          <b>${startDate}</b>, <b>${startTime} to ${endDate}, ${endTime}. </b> Please plan accordingly. Thankyou for your cooperation.`;
  }

  getMaintenanceMessage(startDate: any, startTime: any, endTime: any) {
    return `<b>All services</b> will be <b>unavailable</b> in the application due to scheduled <b>maintenance</b> 
    on <b>${startDate}</b>, from <b>${startTime} to ${endTime}. </b> <br/><br/>
    <b>Please try again later. Thankyou for your cooperation.<b>`
  }

  getDate(date: any) {
    return this.formatDateFromUTCTolocalDate(date, 'dd MMMM yyyy');
  }

  getStartTime(startTime: any) {
    return this.formatDateFromUTCTolocalDate(startTime, 'HH:mm');
  }

  getEndTime(endTime: any) {
    return this.formatDateFromUTCTolocalDate(endTime, 'HH:mm');
  }

  formatDateFromUTCTolocalDate(dateString: any, format = 'yyyy-MM-dd HH:mm:ss') {
    if (!dateString) {
      return '';
    }

    let date: Date;
    if (dateString.toUpperCase().includes('Z')) {
      date = new Date(dateString);
    } else {
      date = new Date(dateString + 'Z');
    }

    if (isNaN(date.getTime())) {
      return '';
    }
    return this.datePipe.transform(date, format) || '';
  }
}
